<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>ICEGATE 06 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>SB No (5444772)<b-badge variant="light" v-b-tooltip.hover title="Shipping Bill Number">?</b-badge></label>
          <input v-model="sbNo" class="form-control" placeholder="e.g. 5444772" />
        </b-col>
        <b-col md="3">
          <label>SB Date(16092011) <b-badge variant="light" v-b-tooltip.hover title="Format: DDMMYYYY">?</b-badge></label>
          <input v-model="sbDt" class="form-control" placeholder="e.g. 16092011" />
        </b-col>
        <b-col md="3" class="align-self-end">
          <b-button v-if="sbNo && sbDt" @click="getAllICEGATE06Func()" size="sm" variant="primary">
            <b-icon icon="search" /> Fetch
          </b-button>
        </b-col>
      </b-row>

      <b-alert v-if="errorMsg" variant="danger" dismissible>{{ errorMsg }}</b-alert>

      <b-card v-if="!isLoading && (sbNo && sbDt) && (getAllICEGATE06.leoDt)" class="mt-4 shadow">
        <b-row>
          <b-col md="6" class="mb-2">
            <b>SB No:</b>
            <span>{{ getAllICEGATE06.sbNo || (getAllICEGATE06.leoDt) || sbNo }}</span>
            <b-button size="sm" variant="outline-secondary" @click="copyToClipboard(getAllICEGATE06.sbNo || (getAllICEGATE06.data && getAllICEGATE06.data.sbNo))" v-b-tooltip.hover title="Copy SB No">
              <b-icon icon="clipboard" />
            </b-button>
          </b-col>
          <b-col md="6" class="mb-2">
            <b>SB Date:</b> <span>{{ getAllICEGATE06.sbDt || (getAllICEGATE06.leoDt) || sbDt }}</span>
          </b-col>
          <b-col md="6" class="mb-2">
            <b>LEO Date:</b>
            <span :class="{'text-danger': !(getAllICEGATE06.leoDt || leoDtDisplay)}">
              {{ getAllICEGATE06.leoDt || leoDtDisplay || 'N/A' }}
            </span>
          </b-col>
        </b-row>
      </b-card>

      <b-alert v-if="!isLoading && (sbNo && sbDt) && !(getAllICEGATE06)" variant="warning" class="mt-4">
        No LEO Date found for this SB No and Date.
      </b-alert>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection.js";
export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllVehicleDDList",
      JSON.stringify({
        itemCode: "getVehicleList",
        vehicleActiveInactiveId: "1",
      })
    );
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllICEGATE06Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      sbNo: '',
      sbDt: '',
      getAllICEGATE06: {},
      isLoading: false,
      error: false,
      errorMsg: '',
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() { },

  beforeDestroy() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  computed: {
    leoDtDisplay() {
      // Try to get from xmlJson, then from getAllICEGATE06.response.response[0].response.leoDt
      if (this.getAllICEGATE06 && this.getAllICEGATE06.xmlJson && this.getAllICEGATE06.xmlJson.leoDt) {
        return this.getAllICEGATE06.xmlJson.leoDt;
      }
      if (
        this.getAllICEGATE06 &&
        this.getAllICEGATE06.response &&
        this.getAllICEGATE06.response.response &&
        Array.isArray(this.getAllICEGATE06.response.response) &&
        this.getAllICEGATE06.response.response[0] &&
        this.getAllICEGATE06.response.response[0].response &&
        this.getAllICEGATE06.response.response[0].response.leoDt
      ) {
        return this.getAllICEGATE06.response.response[0].response.leoDt;
      }
      return '';
    },
  },

  methods: {
    async getAllICEGATE06Func() {
      let payload = {};
      this.isLoading = true;
      this.errorMsg = '';
      this.getAllICEGATE06 = {};

      if (this.sbNo && this.sbDt) {
        payload = {
          itemCode: "ICEGATE06",
          funcUrl: "ICEGATE/06",
          sbNo: this.sbNo,
          sbDt: this.sbDt,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status } = response;
            if (status == 200 && data) {
              if (data.xmlJson) {
                this.getAllICEGATE06 = data.xmlJson;
              } else {
                this.getAllICEGATE06 = data;
              }
            } else {
              this.errorMsg = 'No data found for this SB No and Date.';
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.errorMsg = 'Error fetching data. Please try again.';
            this.isLoading = false;
          });
      }
    },
    copyToClipboard(value) {
      if (!value) return;
      navigator.clipboard.writeText(value);
      this.$bvToast && this.$bvToast.toast('Copied to clipboard!', {
        title: 'Copied',
        variant: 'success',
        solid: true,
        autoHideDelay: 1500
      });
    }
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ICEGATE06_ResponseDisplay.vue?68408006